import React from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const VideoFilters = ({ filters, onFilterChange, onSort, sortBy, sortOrder }) => {
  const sortOptions = [
    { value: 'created_at', label: 'Upload Date' },
    { value: 'level', label: 'Section' },
    { value: 'duration_seconds', label: 'Duration' }
  ];

  const sortOrderOptions = [
    { value: 'asc', label: 'Ascending' },
    { value: 'desc', label: 'Descending' }
  ];

  const handleFilterChange = (field, value) => {
    onFilterChange?.({
      ...filters,
      [field]: value
    });
  };

  const handleClearFilters = () => {
    onFilterChange?.({
      song: '',
      section: '',
      talent: ''
    });
  };

  const hasActiveFilters = Object.values(filters)?.some(value => value?.trim());

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-white">Filters & Search</h3>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClearFilters}
            className="flex items-center space-x-1 text-blue-200 hover:text-white"
          >
            <Icon name="X" size={14} />
            <span>Clear All</span>
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
        {/* Search Filters */}
        <div>
          <label className="block text-sm font-medium text-blue-100 mb-2">
            Song
          </label>
          <Input
            type="text"
            placeholder="Search by song or musical..."
            value={filters?.song}
            onChange={(e) => handleFilterChange('song', e?.target?.value)}
            className="bg-white bg-opacity-10 border-white border-opacity-30 text-white placeholder-blue-200 rounded-lg"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-blue-100 mb-2">
            Section
          </label>
          <Input
            type="text"
            placeholder="Search by section..."
            value={filters?.section}
            onChange={(e) => handleFilterChange('section', e?.target?.value)}
            className="bg-white bg-opacity-10 border-white border-opacity-30 text-white placeholder-blue-200 rounded-lg"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-blue-100 mb-2">
            Talent
          </label>
          <Input
            type="text"
            placeholder="Search by talent name..."
            value={filters?.talent}
            onChange={(e) => handleFilterChange('talent', e?.target?.value)}
            className="bg-white bg-opacity-10 border-white border-opacity-30 text-white placeholder-blue-200 rounded-lg"
          />
        </div>

        {/* Sort Controls */}
        <div>
          <label className="block text-sm font-medium text-blue-100 mb-2">
            Sort By
          </label>
          <Select
            value={sortBy}
            onValueChange={(value) => onSort?.(value, sortOrder)}
            options={sortOptions}
            className="bg-white bg-opacity-10 border-white border-opacity-30 text-white rounded-lg"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-blue-100 mb-2">
            Order
          </label>
          <Select
            value={sortOrder}
            onValueChange={(value) => onSort?.(sortBy, value)}
            options={sortOrderOptions}
            className="bg-white bg-opacity-10 border-white border-opacity-30 text-white rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default VideoFilters;